import { css, html, LitElement } from 'lit';
import { navigator as nav } from 'lit-element-router';

import { RequesterMixin } from '@brightspace-ui/core/mixins/provider-mixin';

import '../components/environment-shell.js';

class Stage extends RequesterMixin(nav(LitElement)) {

  static get properties() {
    return {
      environmentId: { type: String, attribute: 'environment-id' },
      environment: { type: Object, state: true },
    };
  }

  async connectedCallback() {
    super.connectedCallback();
    this.client = this.requestInstance('d2l-pm-client');
    this._refreshing = false;
    this.fetchEnvironment();
  }

  async fetchEnvironment() {
    if (this.environmentId) {
      try {
        this.environment = await this.client.fetchEnvironment(this.environmentId);
      } catch (error) {
        console.error('Error fetching environment:', error);
      }
    }
  }

  _hasTaskManagementTag() {
    return this.environment?.status?.tags?.includes('TASK-MANAGEMENT');
  }

  render() {
    return html`
      <pm-environment-shell
        environment-id="${this.environmentId}"
        .environment="${this.environment}"
        .hasTaskManagement="${this._hasTaskManagementTag()}">
      </pm-environment-shell>
    `;
  }

}

window.customElements.define('pm-stage', Stage);
